import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Router from 'next/router';
import { bindActionCreators } from 'redux';

import {
    cleanText, cdnApi, serverApiEurope, ratingValue, secToTime, bytesToMB, getPodcastImg,
    getPodcastImgSize, convertToSlug, sortUserPlaylists, getDescription, isLocalStoragePresent,
    getCurrentEpisodeData, cleanGenres, singular, getUUID, podcastSlugUrl, podcastHrefUrl, setCurrentPodcastData,
    retrieveLocally,
    secToDateFromPubDate,
    cleanFirebaseId,
    secToDateDay,
    secToDate,
    isAdmin,
    cleanTitleText,
    isBook,
    limitString,
    bookProgressStage
} from '../../lib/utils';
import { spacing, colors, fixedSpacing, minImageWidth, fontSize } from '../../lib/theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { logEpisodeData, getEpisodeFromFirestore, setEpisodeAsPlayed, getPodcastDataDB, fetchAutoChapters, editBookChapter, setEpisodeReadProgress, addToRequestsDetails } from '../../actions';

import { getItunesDataByCollectionId } from '../../lib/searchItunes';
import ExpandCollapse from '../ExpandCollapse';
import Review from '../Review/Review';
import PlayMain from './PlayMain';
import LoadingSpinner from './Loading';
import AutoChapters from './AutoChapters';
import AppShare from './AppShare';
import InvalidPodcast from '../Podcast/InvalidPodcast';
import EmptyState from './EmptyState';

import { Button, Col, Collapse, Input, Menu, message, Modal, notification, Rate, Row, Tabs } from 'antd';
const { TextArea } = Input;
import { CaretRightFilled, CheckCircleOutlined, HeartFilled, PlusCircleOutlined } from '@ant-design/icons';

import NewPlaylist from '../Playlist/NewPlaylist';
import AddPlaylistTile from '../Playlist/AddPlaylistTile';
import AppOptions from './AppOptions';
import EpisodeReviewList from '../Review/EpisodeReviewList';
import { logPodcastEpisodeClick } from '../../lib/analyticsEvents';
import AddToQueue from '../Queue/AddToQueue';
import AppShareModal from './AppShareModal';
import PlayTrailer from './PlayTrailer';
import DownloadEpisode from './DownloadEpisode';
import EpisodeDescription from '../EpisodeDescription';
import InsightSave from './InsightSave';
import BookInProgress from '../Podcast/BookInProgress';
import ChapterImage from './ChapterImage';

const SubMenu = Menu.SubMenu;

class EpisodePageUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            itunesLoaded: false, loadingEpisode: true, visible: false,
            windowWidth: 12000
        };
        // this.props.loadingUserDetailsState(true);
        // this.targetRef = React.createRef();
        this.divRefs = [];
        this.timeoutRef = null;
        this.observer = null;
    }

    componentDidMount() {
        // this.getEpisodeData(this.props.itunesId);
        const { podcastEpisodeServer, podcastEpisodes, userDetails, uuid } = this.props;
        if (uuid) {
            this.getItunesData();
            // this.setEpisodeData(podcastEpisodeServer);

            this.setState({ loadingEpisode: false, windowWidth: window.innerWidth });
        } else {
            this.setState({ windowWidth: window.innerWidth });
        }
        console.dir('episode start');
        // Create an IntersectionObserver
        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        console.log(entry.target.id);
                        const chapterId = entry.target.id;
                        const chapInd = parseInt(chapterId.split('-')[1]);

                        // Clear any existing timeout
                        clearTimeout(this.timeoutRef);

                        // Set a new timer for 3 seconds
                        this.timeoutRef = setTimeout(() => {
                            const currEpisode = podcastEpisodes != null ? podcastEpisodes[chapInd] : podcastEpisodeServer;
                            console.log(`User stayed on Chapter ${chapInd + 1} for 3 seconds.`);
                            console.log(currEpisode.title);
                            if (userDetails && userDetails.uid) {
                                this.props.setEpisodeReadProgress(userDetails.uid, currEpisode);
                            }
                        }, 3000);

                        // // Update the active chapter in state
                        // this.setState({ activeChapter: chapterId });
                    }
                });
            },
            { threshold: 0.3 } // Trigger when at least 50% is visible
        );

        // Start observing each chapter
        const chapterElements = document.querySelectorAll(".chapter");
        chapterElements.forEach((el) => this.observer.observe(el));

        const initialIndex = (podcastEpisodes || []).findIndex(el => el.guid == podcastEpisodeServer.guid);
        if (initialIndex > -1) {
            this.divRefs[initialIndex]?.scrollIntoView({ behavior: "auto" });
        }
    }

    componentDidUpdate(prevProps) {
        const { podcastEpisodeServer, uuid } = this.props;
        if (uuid && uuid !== prevProps.uuid) {
            this.setState({ itunesLoaded: false, loadingEpisode: true });

            this.getItunesData();
            // this.setEpisodeData(podcastEpisodeServer);

            this.setState({ loadingEpisode: false });
        }
    }

    componentWillUnmount() {
        // Clean up the observer and any active timeout
        if (this.observer) {
            this.observer.disconnect();
        }
        clearTimeout(this.timeoutRef);
    }

    // async setEpisodeData(podcastEpisodeServer) {
    //     const { isServer, uuid } = this.props;
    //     let logData = false;
    //     let episodeLocal;
    //     this.setEpisodeAutoChapters();
    //     if (isServer) {
    //         if (!podcastEpisodeServer.guid) {
    //             episodeLocal = this.setLocalEpisodeData();
    //             logData = true;
    //         }
    //     } else {
    //         episodeLocal = this.setLocalEpisodeData();
    //         try {
    //             // ///*********** use serverApi here as you need to check and log data. */
    //             // const response = await fetch(`${serverApiEurope}episodes?id=${(guid)}`);
    //             // let episodeData = await response.json();
    //             let episodeData = await getEpisodeFromFirestore(uuid);
    //             this.setState({ episodeClient: episodeData });
    //             console.dir(episodeData);
    //             if (!episodeData.guid) {
    //                 logData = true;
    //             } else {
    //                 // if (this.props.type !== 'drawer') { ************ don't uncomment this, causes an issue in episode search
    //                 this.setState({ episodeClient: episodeData });
    //                 // }
    //                 if (episodeData && episodeData.collectionId) {
    //                     // if (episodeData.collectionId > 0) {
    //                     //     getItunesDataByCollectionId(episodeData.collectionId).then((data) => {
    //                     //         console.dir(data);
    //                     //         this.setState({ itunesLoaded: true, itunesData: data });
    //                     //     })
    //                     // } else {
    //                     //     getPodcastDataDB(episodeData.collectionId).then((data) => {
    //                     //         console.dir(data);
    //                     //         this.setState({ itunesLoaded: true, itunesData: data });
    //                     //     })
    //                     // }
    //                 }
    //             }
    //         } catch (error) {
    //             console.error(error);
    //             // throw error;
    //         }
    //     }

    //     if (logData && episodeLocal && episodeLocal.guid) {
    //         // if an episode is not already on server, log it in server through cloud functions
    //         logEpisodeData(episodeLocal).then(() => console.log(true)).catch(err => console.error(err));
    //     }
    // }

    setEpisodeAutoChapters() {
        const { uuid } = this.props;
        console.dir(uuid);
        // this.props.fetchAutoChapters(uuid);
    }

    setLocalEpisodeData() {
        // let episodeLocal = this.getCurrentEpisode();
        // this.setState({ episodeClient: episodeLocal });
        return {};
    }

    getCurrentEpisode = () => {
        const { podcastEpisodeServer } = this.props;
        if (podcastEpisodeServer && podcastEpisodeServer.guid) {
            return podcastEpisodeServer;
        }
        let episodeLocalParse;
        if (isLocalStoragePresent() && localStorage.getItem('lastLocalEpisode') !== null) {
            episodeLocalParse = JSON.parse(localStorage.getItem('lastLocalEpisode'));
        } else {
            episodeLocalParse = getCurrentEpisodeData();
        }
        return episodeLocalParse;
    }

    getItunesData() {
        let episodeLocal = this.getCurrentEpisode();
        const itunesId = episodeLocal.collectionId;
        if (itunesId && itunesId > 0) {
            // getItunesDataByCollectionId(itunesId).then((data) => {
            //     this.setState({ itunesLoaded: true, itunesData: data })
            // })
        }
        logPodcastEpisodeClick(episodeLocal);
    }

    backToSeries = () => {
        const { onCloseChild } = this.props;
        if (onCloseChild) {
            onCloseChild();
        }
        // let episodeLocal = this.getCurrentEpisode();
        const { itunesData } = this.state;
        console.dir(itunesData);
        if (itunesData && itunesData.feedUrl) {
            const itunesId = itunesData.collectionId;
            // let cleanedGenres = cleanGenres(itunesData.genres);
            // let genres = cleanedGenres.join(',');
            setCurrentPodcastData(itunesData);
            Router.push(podcastHrefUrl(itunesId), podcastSlugUrl(itunesData.collectionName, itunesId));
        }
    }

    isInAnyPlaylist() {
        let inPlaylist = false;
        let episodeLocal = this.getCurrentEpisode();
        const guid = episodeLocal.guid;
        const { userPlaylists } = this.props;
        // const { episodeClient } = this.state;
        // const podcastEpisode = (podcastEpisodeServer.guid) ? podcastEpisodeServer : episodeClient;
        for (let playlist of Object.values(userPlaylists)) {
            if (!inPlaylist && playlist['guidEpisodeArray']) {
                for (let guidPlaylist of playlist['guidEpisodeArray']) {
                    // let episodeGUID = podcastEpisode['guid'] || '';
                    if (guidPlaylist == guid) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    markPlayedClick = (isMarkedAsPlayed) => {
        const { podcastEpisodeServer, userDetails } = this.props;
        const { episodeClient } = this.state;
        const podcastEpisode = (podcastEpisodeServer.guid) ? podcastEpisodeServer : episodeClient;
        if (!userDetails || !userDetails.uid) {
            message.warning('Please sign in to mark as played.');
            return;
        }
        this.props.setEpisodeAsPlayed(podcastEpisode, !isMarkedAsPlayed);
    }

    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    handleCancel = e => {
        console.log(e);
        this.setState({
            visible: false,
        });
    };
    changeTitle = e => {
        const { episodeClient } = this.state;
        this.setState({ episodeClient: { ...episodeClient, title: e.target.value } });
    }
    saveTitle = () => {
        if (window.confirm("Are you sure?")) {
            const { episodeClient } = this.state;
            // const { insight } = this.state;
            // const { guid } = this.props;
            editBookChapter(episodeClient.guid, '', '', episodeClient.title).then(() => {
                message.success('Updated Title.');
            }).catch(err => {
                alert('There was an error saving. Contact suboo');
            })
            return;
        }
    }

    // Scroll to a specific div based on its index
    scrollToDiv = (index) => {
        this.divRefs[index]?.scrollIntoView({ behavior: "smooth" });
    };

    playNotReady = () => {
        const { requestedBooks, itunesData } = this.props;
        Modal.info({
            title: 'Audio for this book is in progress',
            content: (
                <p>Want the audio sooner? Request it below, and we’ll prioritize adding it in 3 working days!</p>
            ),
            okText: requestedBooks[itunesData.collectionId] ? 'Requested' : 'Request',
            maskClosable: true,
            onOk: () => {
                const { itunesData } = this.props;
                if (requestedBooks[itunesData.collectionId]) {
                    return;
                }
                const bookProgressStageVal =
                    bookProgressStage(itunesData);
                console.dir(bookProgressStageVal);

                this.props.addToRequestsDetails(
                    itunesData.collectionName,
                    itunesData.artistName,
                    Date.now(),
                    itunesData.collectionId,
                    bookProgressStageVal,
                );
                console.dir(bookProgressStageVal);
                notification.info({
                    duration: 0,
                    message: "Thank you for your request! We've received it and will prioritize adding audio within the next 3 working days.",
                });
            },
        });
    }

    render() {
        const { userDetails, podcastEpisodeServer, podcastEpisodes, userPlaylists, type, personalMarkPlayedValues,
            appEpisodeNumber, personalValues, myFiles, uuid, rawTokenCount, description, itunesData } = this.props;
        const { episodeClient, itunesLoaded, loadingEpisode, visible, windowWidth } = this.state;
        console.dir(rawTokenCount);
        console.dir(appEpisodeNumber);
        const podcastEpisode = podcastEpisodeServer; //(podcastEpisodeServer.guid) ? podcastEpisodeServer : episodeClient;
        // console.dir(episodeClient);
        console.dir(podcastEpisodeServer);
        console.dir(podcastEpisodeServer.guid);
        // console.dir(episodeClient);
        // let episodeLocal = this.getCurrentEpisode();
        const guid = podcastEpisode?.guid;
        const isMobile = windowWidth < 767;
        console.dir(windowWidth);
        console.dir(isMobile);

        if (!podcastEpisode || !guid) {
            // return (<InvalidPodcast message="Sorry we couldn't find this episode. Please check the url and try again." />)
            return <></>
            // return <EmptyState message="Sorry we couldn't find this episode. Please try again or search in a similar podcast." imageName='podcast-not-found' />
        }

        // const { loadingEpisodeReviews } = this.props.loadingState;
        // const { userDetails } = this.props;
        const pubDateParsed = podcastEpisode.pubDate ? new Date(podcastEpisode.pubDate) : '';

        const isUserAdmin = isAdmin(userDetails);

        let userPlaylistsSorted = sortUserPlaylists(userPlaylists, userDetails); // {};
        // Object
        //     .keys(userPlaylists).sort(function (a, b) {
        //         return userPlaylists[a].name.localeCompare(userPlaylists[b].name);
        //     })
        //     .forEach(function (key) {
        //         userPlaylistsSorted[key] = userPlaylists[key];
        //     });

        const guidCleaned = cleanFirebaseId(podcastEpisode.guid);
        const personalMarkPlayedValuesSpecific = personalMarkPlayedValues[`${guidCleaned}`] || false;
        const personalValuesSpecific = personalValues[`${guidCleaned}`] || {};
        const isMarkedAsPlayed = personalMarkPlayedValuesSpecific || personalValuesSpecific['markAsPlayed'] || false;

        const menu = (
            <Menu>
                <Menu.Item key="download"><DownloadEpisode podcastEpisode={podcastEpisode} /></Menu.Item>
                <Menu.Item key="markAsPlayed">
                    <a onClick={this.markPlayedClick.bind(this, isMarkedAsPlayed)}>
                        <p className='mb-0'>
                            <FontAwesomeIcon style={{ marginRight: '4px' }} icon={isMarkedAsPlayed ? 'times-circle' : 'check-circle'} />
                            {isMarkedAsPlayed ? 'Mark as Unplayed' : 'Mark as Played'}
                        </p>
                    </a>
                </Menu.Item>
                <SubMenu title={<div style={{ display: 'inline' }}>
                    <p style={{ display: 'inline' }}>
                        {this.isInAnyPlaylist() ? <CheckCircleOutlined style={{ color: 'green' }} /> : <PlusCircleOutlined />}&nbsp;Add to Playlist</p>
                </div>}>
                    <Menu.Item key="newPlaylist" style={{ padding: '0' }}><NewPlaylist podcastDetails={podcastEpisode} /></Menu.Item>
                    <Menu.Divider />
                    {userDetails && Object.values(userPlaylists).length > 0 && Object.keys(userPlaylistsSorted).map((userPlaylistId) => (
                        <Menu.Item key={userPlaylistId}>
                            <AddPlaylistTile key={userPlaylistId} userPlaylistId={userPlaylistId} userPlaylist={userPlaylistsSorted[userPlaylistId]}
                                podcastEpisode={podcastEpisode} />
                        </Menu.Item>

                    ))
                    }
                </SubMenu>
                <Menu.Item key="addToQueue"><AddToQueue podcastEpisode={podcastEpisode} /></Menu.Item>
            </Menu>
        );

        const episodeShareUrl = `https://tedapp.ai/episode/${getUUID(podcastEpisode?.guid || '')}`;

        const isDrawer = type === 'drawer';
        const isMyFile = podcastEpisode.isMyFile;
        console.dir(itunesData);
        const bookProgressStageVal =
            bookProgressStage(itunesData);
        console.dir(bookProgressStageVal);
        const showTextContent = bookProgressStageVal >= 30;
        const hasAudio = bookProgressStageVal >= 40;
        const isNews = itunesData?.type == 2;
        // console.dir(podcastEpisodes);
        // console.dir(podcastEpisode);

        return (
            <div className='list'>
                {/* {!isMyFile &&
                    <Button type='' style={{ marginBottom: `${spacing()}` }} disabled={!itunesLoaded || !itunesData || !itunesData.feedUrl} onClick={this.backToSeries}>Go to Series</Button>
                } */}
                {windowWidth != 12000 && ((podcastEpisodes ?? []).length > 1 ? <div className='side-chaps'>
                    <Collapse defaultActiveKey={[`${isMobile ? 3 : 1}`]}>
                        <Collapse.Panel header="Key Ideas" key="1">

                            {podcastEpisodes.map((podcastEpisode, index) => (
                                <div key={index} className='chap-card' onClick={() => this.scrollToDiv(index)}>
                                    <p className='serif mb-0'>{index + 1}&#46; {limitString(cleanTitleText(podcastEpisode.title), (podcastEpisodes.length > 11 ? 30 : 60))}</p>
                                    <hr className='separator' />
                                </div>
                            ))}
                        </Collapse.Panel>
                    </Collapse>
                </div> : <div className='side-chaps'><Button onClick={this.props.backToSeries}>See Full Summary</Button>
                </div>)}
                {(podcastEpisodes ?? [podcastEpisode]).map((podcastEpisode, index) => (
                    <div key={index}
                        id={`chapter-${index}`}
                        className="chapter"
                    >
                        {podcastEpisode.guid &&
                            <div
                                ref={(ref) => (this.divRefs[index] = ref)} // Assign each div a ref
                                className='desc-view'>
                                {(podcastEpisodes ?? []).length > 1 && <p>KEY IDEA {index + 1} OF {podcastEpisodes.length}</p>}
                                <h2>{cleanTitleText(podcastEpisode.title)}</h2>
                                {!isNews && <>
                                    {(hasAudio && podcastEpisode?.enclosure?.url) ?
                                        <Row style={{ width: '160px', margin: '0.75em auto', marginBottom: '1em' }}>
                                            <Col xs={17} xl={18}>
                                                <PlayMain style={{ width: '11vw' }} podcastEpisode={podcastEpisode} iconType='button' />
                                            </Col>
                                            {/* <Col style={{ textAlign: 'right', marginTop: `${spacing('xs')}` }} xs={7} xl={6}>
                        {
                            <Dropdown overlay={menu} trigger={['click']}>
                                <a className="ant-dropdown-link" href="#">
                                    <AppOptions />
                                </a>
                            </Dropdown>
                        }
                    </Col> */}
                                        </Row> :
                                        <div style={{ marginBottom: '12px', textAlign: 'center' }}>
                                            <Button type='primary' style={{ padding: '0 32px' }} onClick={this.playNotReady}>
                                                <CaretRightFilled style={{ fontSize: fontSize }} /> Play</Button>
                                        </div>
                                    }
                                </>}
                                <div style={{ textAlign: 'center', marginBottom: '12px' }}>
                                    <ChapterImage collectionId={podcastEpisode.collectionId}
                                        width={'100%'}
                                        thumbnail={podcastEpisode.thumbnail || ''} />
                                </div>
                                {/* <p>{podcastEpisode.description}</p> */}
                                {showTextContent ? <div className=''><p className='serif dark desc' dangerouslySetInnerHTML={{
                                    __html: (podcastEpisode.description || '').replaceAll('\n', '<br />')
                                        .replaceAll('[[', '<b>')
                                        .replaceAll(']]', '</b>')
                                }} /></div> :
                                    <div>
                                        <BookInProgress itunesData={itunesData} />
                                    </div>
                                }
                                {showTextContent && podcastEpisode.insight &&
                                    <div className='insight'>
                                        <h4>
                                            <FontAwesomeIcon style={{ marginRight: '6px', color: '#ffbf00' }} icon={'lightbulb'} />
                                            INSIGHT</h4>
                                        <p className='serif'>{podcastEpisode.insight}</p>
                                        <div style={{ textAlign: 'right' }}>
                                            <InsightSave guid={podcastEpisode.guid} collectionId={podcastEpisode.collectionId} />
                                        </div>
                                    </div>}
                                <div style={{ height: '80px' }}></div>

                            </div>
                        }
                    </div>
                ))}
                {loadingEpisode && <LoadingSpinner message='Loading episode...' />}
                {!loadingEpisode && (!podcastEpisodes || podcastEpisodes.length < 1) &&
                    // <InvalidPodcast message="Sorry we couldn't find this episode. Please try again or search in a similar podcast." />
                    <EmptyState message="Sorry we couldn't find this episode. Please try again or search in a similar podcast." imageName='podcast-not-found' />
                }
                <style jsx>
                    {`
                    .side-chaps {
                        top: 9px;
                        position: fixed;
                        width: 298px;
                        right: 16px;
                        overflow: auto;
                        z-index: 1;
                    }
                    .chap-card {
                        //    box-shadow: 0 2px 12px 0 rgba(0, 11, 20, .04);
                        padding: 1px 16px;
                        // margin-bottom: 6px;
                        margin-right: 16px;
                        cursor: pointer;
                    }
                // h2 {
                //   margin-bottom: ${spacing('xxs')};
                // }
                :global(.ant-collapse-content > .ant-collapse-content-box) {
                    padding: 16px 0;
                }
                .episode-title{
                    display: inline;
                    font-size: ${fontSize('md')};
                }
                .desc-view {
                    max-width: 640px;
                    margin: auto;
                    padding-top: 32px;
                }
                .desc {
                    // color: black;
                    font-size: 1.2em;
                    line-height: 32px;
                }
                .insight {
                    padding: 16px 24px;
                    border-radius: 12px;
                    margin-bottom: 16px;
                    box-shadow: 0 20px 40px 0 rgba(0,11,40,.14);
                }
                .main-img-loc {
                    max-width: 100%;
                    // width: 11vw;
                    // min-height: 160px;
                    // min-width: ${minImageWidth};
                    margin-right: ${spacing('lg')};
                    margin-bottom: ${spacing('md')};
                    border-radius: 1em; // ${spacing('lg')};
                    box-shadow: 0 20px 40px 0 rgba(0,11,40,.14); // 0 8px 8px rgba(0,0,0,0.30), 0 4px 4px rgba(0,0,0,0.22);
            //   box-shadow: 0 8px 8px rgba(0,0,0,0.30), 0 4px 4px rgba(0,0,0,0.22);
                }
                :global(.app-rating .ant-rate-star > div:hover, .app-rating .ant-rate-star > div:focus) {
                    transform: scale(1);
                }
            `}
                </style>
            </div>
        );
    }
}

EpisodePageUser.propTypes = {
    podcastEpisodeServer: PropTypes.object,
    itunesData: PropTypes.object,
    podcastEpisodes: PropTypes.array,
    // guid: PropTypes.string,
    uuid: PropTypes.string,
    type: PropTypes.string,
    description: PropTypes.any,
    // itunesId: PropTypes.string,
    userDetails: PropTypes.object,
    loadingState: PropTypes.object,
    userPlaylists: PropTypes.object,
    onCloseChild: PropTypes.func,
    loadingEpisodeReviews: PropTypes.bool,
    isServer: PropTypes.bool,
    appEpisodeNumber: PropTypes.any,
    personalValues: PropTypes.object,
    rawTokenCount: PropTypes.object,
    personalMarkPlayedValues: PropTypes.object,
    setEpisodeAsPlayed: PropTypes.func,
    fetchAutoChapters: PropTypes.func,
    setEpisodeReadProgress: PropTypes.func,
    backToSeries: PropTypes.func,
    addToRequestsDetails: PropTypes.func,
    myFiles: PropTypes.object,
    requestedBooks: PropTypes.object,
}

EpisodePageUser.defaultProps = {
    type: 'page'
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
        loadingState: state.loadingState,
        userPlaylists: state.userPlaylists,
        personalValues: state.personalValues,
        personalMarkPlayedValues: state.personalMarkPlayedValues,
        myFiles: state.myFileEpisodes,
        requestedBooks: state.requestedBooks,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setEpisodeAsPlayed: bindActionCreators(setEpisodeAsPlayed, dispatch),
        fetchAutoChapters: bindActionCreators(fetchAutoChapters, dispatch),
        setEpisodeReadProgress: bindActionCreators(setEpisodeReadProgress, dispatch),
        addToRequestsDetails: bindActionCreators(addToRequestsDetails, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(EpisodePageUser);
